import type { SVGProps } from 'react';
export const Logout = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4.35 4.35h3.93a.68.68 0 1 0 0-1.35H4.25A1.25 1.25 0 0 0 3 4.25v11.5A1.25 1.25 0 0 0 4.25 17h4.03a.68.68 0 0 0 0-1.35H4.35zm8.48 2.15c.26-.26.69-.26.95 0l3.02 3.02c.27.27.27.7 0 .96l-3.02 3.02a.68.68 0 1 1-.95-.96l1.86-1.86H8.28a.68.68 0 0 1 0-1.36h6.4l-1.85-1.86a.7.7 0 0 1 0-.96"
      clipRule="evenodd"
    />
  </svg>
);
